import React, { Component } from 'react';
import FormicaSearchSelectBox, { FormicaSelectBoxItem } from '../../../custom/FormicaSearchSelectBox';
import { CaseSettings } from '../../../../domain/case/CaseDomains';
import { RootState } from '../../../../redux/store';
import { PageState } from '../../../../redux/reducers/PageReducer';
import { UserSystemAttributes } from '../../../../domain/rbac/RbacDomains';
import { ComponentState } from '../../../../redux/actions/ComponentActions';
import { CaseState } from '../../../../redux/reducers/CaseReducer';
import { connect } from 'react-redux';
import { changePageFilter, clearPage } from '../../../../redux/actions/PageActions';
import { changeCaseColumns } from '../../../../redux/actions/CaseActions';
import { setAttribute } from '../../../../redux/actions/UserActions';
import { ConnectedProps } from 'react-redux/es/exports';
import Icon from '../../../../icons/Icon';
import { Dialog } from 'primereact/dialog';
import FileUploader, { UploadProgress } from '../../../sandbox/FileUploader';
import EnvironmentUtil from '../../../../util/EnvironmentUtil';
import FormicaLabel from '../../../custom/FormicaLabel';
import AnimatedButton from '../../../custom/AnimatedButton';
import FormicaToggleSwitch from '../../../custom/FormicaToggleSwitch';
import CollectionNames from '../../../../constant/CollectionNames';
import { query, repository } from '@trlogic/client-js';
import { apiUrl, InstanceContainer } from '../../../../config/binding/InstanceBinding';
import Injectables from '../../../../constant/Injectables';
import { TransactionJsonModel } from '../../../../domain/stream/transaction/TransactionDomains';
import DataType from '../../../../constant/DataType';
import HttpMethod from '../../../../constant/HttpMethod';
import MessageUtil from '../../../../util/MessageUtil';
import HttpClient from '../../../../gateway/HttpClient';
import GatewayContainer from '../../../../config/GatewayContainer';
import GatewayNames from '../../../../constant/GatewayNames';
import QueryBuilder = query.QueryBuilder;
import eq = query.eq;
import LanguageUtil from '../../../../util/LanguageUtil';

class TransactionMarkComponent extends Component<Props, State> {
  public state: State = new State();

  private httpClient: HttpClient = GatewayContainer.getInstance().get(GatewayNames.API_CLIENT);
  private readonly repository: repository.ReadOnlyQueryableRepository = InstanceContainer.get(Injectables.REPOSITORY);
  private readonly environmentUtil: EnvironmentUtil = InstanceContainer.get(Injectables.ENVIRONMENT_UTIL);

  public render() {
    const { markVisible, onHideMark } = this.props;
    return (
      <Dialog
        header={this.getHeader}
        className={'mark-dialog w-1/3 h-2/3'}
        closable={false}
        closeOnEscape={true}
        dismissableMask={true}
        visible={markVisible}
        onHide={onHideMark}
      >
        {this.getContent()}
      </Dialog>
    );
  }

  public async componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    if (prevProps.currentCaseSettings != this.props.currentCaseSettings) {
      const { currentCaseSettings } = this.props;
      const transactionQuery = QueryBuilder.select().from(CollectionNames.TRANSACTIONS).where(eq('id', currentCaseSettings?.dataSource)).build();
      const channel = await this.repository.find<TransactionJsonModel>(transactionQuery);
      this.setState({ channel });
    }
  }

  private getHeader = () => {
    return (
      <div className={'bg-main-gray h-[54px] rounded-t-[6px] flex items-center justify-between align-center pl-[20px] pr-[20px]'}>
        <div className={'flex items-center justify-start align-center w-full lg:w-auto gap-2'}>
          <Icon icon={'marktransactions'} size={18} color={'#4F4F4F'} />
          <span className={'text-f-black-2 text-[14px] font-medium'}>
            {LanguageUtil.get({ id: 'common.label.markTransactions', defaultMessage: 'Mark Transactions' })}
          </span>
        </div>
      </div>
    );
  };

  private getContent = () => {
    const { file, progress, percent, variableMarked, variablePositive, variableMatch } = this.state;
    const { onHideMark } = this.props;
    return (
      <div className={'flex flex-col gap-y-4 w-full h-full px-5 py-4'}>
        <div className={'flex flex-col w-full'}>
          <FormicaLabel label={'Upload csv file'} />
          <div className={'flex flex-col gap-y-2 items-center justify-center w-full h-[240px] border-1 border-[#E0E4E8] rounded-xl bg-[#F9FAFB]'}>
            <FileUploader
              acceptedFiles={['text/csv']}
              file={file}
              percent={percent}
              progress={progress}
              onChangeFile={(file) => this.setState({ file })}
              maxBytes={this.environmentUtil.getStorageMaxSize()}
            />
          </div>
        </div>
        <div className={'flex flex-col gap-y-4'}>
          <div className={'flex flex-col w-full'}>
            <FormicaLabel label={'Select the variable corresponding to the data in the uploaded file'} />
            <FormicaSearchSelectBox
              options={this.getMatchOptionsMenu()}
              rounded
              placeholder={LanguageUtil.get({ id: 'common.input.placeholder.selectVariable', defaultMessage: 'Select variable' })}
              value={variableMatch}
              onChange={(e: FormicaSelectBoxItem) => this.setState({ variableMatch: e.value })}
            />
          </div>
          <div className={'flex flex-col w-full'}>
            <FormicaLabel label={'Select the variable to be marked'} />
            <FormicaSearchSelectBox
              options={this.getMarkedOptionsMenu()}
              rounded
              placeholder={LanguageUtil.get({ id: 'common.input.placeholder.selectVariable', defaultMessage: 'Select variable' })}
              value={variableMarked}
              onChange={(e: FormicaSelectBoxItem) => this.setState({ variableMarked: e.value })}
            />
          </div>
          <div className={'flex flex-col w-full'}>
            <FormicaLabel label={'Mark the variable as positive'} />
            <FormicaToggleSwitch value={variablePositive} large={true} onChange={() => this.setState({ variablePositive: !variablePositive })} />
          </div>
        </div>
        <div className={'py-5 flex gap-x-5 justify-end'}>
          <AnimatedButton
            text={LanguageUtil.get({ id: 'common.label.cancel', defaultMessage: 'Cancel' })}
            customType={'secondary'}
            customSize={'sm'}
            icon={'multiplier'}
            onClick={onHideMark}
          />
          <AnimatedButton
            text={LanguageUtil.get({ id: 'common.label.submit', defaultMessage: 'Submit' })}
            customType={'primary'}
            customSize={'sm'}
            icon={'add'}
            onClick={this.submit}
          />
        </div>
      </div>
    );
  };

  private getMatchOptionsMenu = (): FormicaSelectBoxItem[] => {
    const { channel } = this.state;
    return (
      channel?.variables?.map((variable) => {
        return { label: variable.name, value: variable.name };
      }) || []
    );
  };

  private getMarkedOptionsMenu = (): FormicaSelectBoxItem[] => {
    const { channel } = this.state;
    return (
      channel?.variables
        ?.filter((variable) => variable.properties.dataType == DataType.BOOLEAN)
        .map((variable) => {
          return { label: variable.name, value: variable.name };
        }) || []
    );
  };

  private submit = async () => {
    const { file, variablePositive, variableMatch, variableMarked } = this.state;
    const { currentCaseSettings } = this.props;
    const endpoint = `${apiUrl}/file/mark-transactions/csv`;
    if (file == undefined || variableMarked == undefined || variableMatch == undefined || currentCaseSettings?.dataSource == undefined) return;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('variableMatch', variableMatch);
    formData.append('variableMarked', variableMarked);
    formData.append('variablePositive', variablePositive ? 'true' : 'false');
    formData.append('dataSource', currentCaseSettings.dataSource);
    try {
      await this.httpClient.execute(HttpMethod.POST, endpoint, formData, undefined, undefined, (progressEvent: ProgressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        this.setState({ percent: percentCompleted, progress: 'uploading' });
      });
      MessageUtil.success({
        summary: 'Mark Transaction',
        detail: <div>Transactions marking started!</div>,
      });
    } catch (e) {
      MessageUtil.error({
        summary: 'Mark Transaction',
        detail: <div>Transactions marking error!</div>,
      });
      console.error(e);
    }
  };
}

class State {
  percent: number = 0;
  progress: UploadProgress = 'idle';
  file: File | null = null;
  variableMatch: string | undefined;
  variableMarked: string | undefined;
  variablePositive: boolean = true;
  channel: TransactionJsonModel | undefined;
}

interface Props extends ReduxProps {
  currentCaseSettings: CaseSettings | undefined;
  markVisible: boolean;
  onHideMark: () => void;
}

const mapStateToProps = (state: RootState) => ({
  user: state.auth.user,
  page: state.page as PageState,
  attributes: state.auth.attributes as UserSystemAttributes,
  component: state.component as ComponentState,
  case: state.case as CaseState,
});
const connector = connect(mapStateToProps, { clearPage, changePageFilter, changeCaseColumns, setAttribute });
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(TransactionMarkComponent);
